module.exports = __webpack_public_path__ + "img/splash-logo.482783d1.gif";